import round from 'lodash/round';
import toNumber from 'lodash/toNumber';
import { currencyFormatter } from '@thesavingsgroup/utils/currencyFormatter';
import { currencyFormatterNoCents } from '@thesavingsgroup/utils/currencyFormatterNoCents';
import { stripNonNumericCharacters } from '@thesavingsgroup/utils/stripNonNumericCharacters';
import type { RateForDisplay } from './types/RateForDisplay';
import type { GetRateForDisplayParams } from './types/GetRateForDisplayParams';
import { calculateMonthlyPayment } from './calculateMonthlyPayment';
import { toRateNumber } from './toRateNumber';
import { convertApr } from './convertApr';

export const getRateForDisplay = ({
  apr,
  brand,
  downPayment,
  loanAmount,
  loanTerm,
}: GetRateForDisplayParams): RateForDisplay => {
  const loanAmountAsNumber = toNumber(stripNonNumericCharacters(loanAmount));
  const loanTermAsNumber = Number(loanTerm);

  const { asDecimal, asPercent } = convertApr(apr);

  const monthlyPayment = calculateMonthlyPayment(
    asDecimal,
    loanTermAsNumber,
    toRateNumber(loanAmount),
    downPayment,
  );

  const roundedApr = round(asPercent, 2);

  return {
    apr: roundedApr,
    aprAsString: `${roundedApr}%`,
    brand,
    loanAmount: loanAmountAsNumber,
    loanAmountAsString: currencyFormatterNoCents.format(loanAmountAsNumber),
    loanTerm: loanTermAsNumber,
    loanTermAsString: `${loanTerm} months`,
    payment: monthlyPayment,
    paymentAsString: `${currencyFormatter.format(monthlyPayment)}/mo`,
  };
};
